import {
  type ResolvedSound,
  SOUND_EVENTS,
  type SoundEventKey,
  type SoundSetting,
  type SoundSettings,
} from "@loot-os/api-contract";
import { Card, CardContent, CardHeader, CardTitle } from "@loot-os/ui/components/card";

import { SoundRow } from "./SoundRow";

const GROUPS = [...new Set(SOUND_EVENTS.map((e) => e.group))];

/**
 * Every sound event as a row, grouped. `own` is what this page's scope stored (an environment's
 * overrides, or the platform's defaults) and `resolved` is what plays. Failures are toasts from
 * the mutation cache, so `onUpload` and `onSet` may reject and this renders no errors.
 */
export function SoundList({
  scope,
  sounds,
  canEdit,
  onUpload,
  onSet,
}: {
  scope: "platform" | "tenant";
  sounds: { own: SoundSettings; resolved: Partial<Record<SoundEventKey, ResolvedSound>> };
  canEdit: boolean;
  onUpload: (event: SoundEventKey, file: File) => void | Promise<void>;
  onSet: (event: SoundEventKey, setting: SoundSetting | null) => void | Promise<void>;
}) {
  return (
    <div className="grid gap-6">
      {GROUPS.map((group) => (
        <Card key={group}>
          <CardHeader>
            <CardTitle>{group}</CardTitle>
          </CardHeader>
          <CardContent className="divide-y">
            {SOUND_EVENTS.filter((e) => e.group === group).map((event) => (
              <SoundRow
                key={event.key}
                event={event}
                events={SOUND_EVENTS}
                scope={scope}
                resolved={sounds.resolved[event.key]}
                own={sounds.own[event.key]}
                canEdit={canEdit}
                onUpload={(file) => onUpload(event.key, file)}
                onSet={(setting) => onSet(event.key, setting)}
              />
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
